import React, { useState, useEffect } from "react"
import _ from "lodash"

import { Button_s, Label_s} from 'styles/app-styles'

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"

const BreakpointBasic = (props: {rowData: [], field: string, namedItems: {}, defaults: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>(_.get(props, "rowData.breakpointdetail"));

  const emptyRecord = {}

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field]['state'] !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData():void {
    let nextData = _.cloneDeep(data)
    nextData = {
      state: 'basic',
      breakPoint: 'Natural'
    }

    setData(nextData);
    props.persist(nextData, 'breakpointdetail', props.rowData)
  }

  const isBasic = _.get(data, 'state') == 'basic'

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          { isBasic
            ? <Label_s>Natural Breakpoint Selected</Label_s>
            : <Button_s className="rounded btn" onClick={() => updateData()}>Select Natural Breakpoint</Button_s>
          }
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default BreakpointBasic
